var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer"},[_vm._v(" moov'on © 2017 - "+_vm._s(new Date().getFullYear())+" : v.1.38.0 - 07 Juillet 2026 - node 22.x ")])
}
var staticRenderFns = []

export { render, staticRenderFns }